import MiAppsManagement from './application';
import { install } from '../../../utils/install';
export default install(MiAppsManagement);
